<button mat-icon-button class="close-button" [mat-dialog-close]="false">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
  <mat-card class="p-0">
        <form [formGroup]="vendedorForm" (ngSubmit)="submit()">
          <div fxLayout="row wrap" fxLayout.lt-sm="column">
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <mat-label>Vendedor</mat-label>
                <mat-select [formControl]="vendedorForm?.controls['vendedor']!" (selectionChange)="onSelectionChangeVendedor($event)">
                  <mat-option>
                    <ngx-mat-select-search [formControl]="vendedorForm?.controls['searchVendedor']!" placeholderLabel="Pesquisar Vendedor."
                      noEntriesFoundLabel="Vendedor/Representante não encontrado" [searching]="searching">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let vendedor of vendedores" [value]="vendedor">
                    <span>{{ vendedor?.codigo?.toString().padStart(9, '0') +"-" + vendedor?.razaoSocial}}</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <small
                *ngIf="vendedorForm.controls['vendedor'].hasError('required') && vendedorForm.controls['vendedor'].touched"
                class="form-error-msg"> Vendedor/Representante é obrigatório </small>
            </div>
          </div>
        </form>
  </mat-card>
</div>
<mat-dialog-actions>
  <div fxFlex="100" class="mt-1">
      <button class="mb-8" mat-raised-button [matTooltip]="'Salvar Vendedor/Representante'" color="primary"
      [disabled]="vendedorForm.invalid" (click)="this.save();$event.preventDefault();"><mat-icon>save</mat-icon>{{"SAVE" |
          translate }}
      </button>
      <span fxFlex></span>
      <button mat-button color="warn" type="button" (click)="dialogRef.close(false)"><mat-icon>close</mat-icon>{{"CLOSE" | translate }}</button>
  </div>
</mat-dialog-actions>


